import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import List from './List';
import Details from './Details';
import TemplateBuilder from './TemplateBuilder';
import TemplateViewer from './TemplateViewer';

const AgencyAdminRoutes: React.FC = () => (
  <Routes>
    <Route
      index
      element={<List />}
    />
    <Route
      path='details/:id/*'
      element={<Details />}
    />
    <Route
      path='builder/:id'
      element={<TemplateBuilder />}
    />
    <Route
      path='view/:id'
      element={<TemplateViewer />}
    />
    {/* Redirect /new to list - agency cannot create templates */}
    <Route
      path='new'
      element={
        <Navigate
          to=''
          replace
        />
      }
    />
    <Route
      path='*'
      element={
        <Navigate
          to=''
          replace
        />
      }
    />
  </Routes>
);

export default AgencyAdminRoutes;

